import { render, staticRenderFns } from "./UserEditDetails.vue?vue&type=template&id=795c905e&scoped=true"
import script from "./UserEditDetails.vue?vue&type=script&lang=js"
export * from "./UserEditDetails.vue?vue&type=script&lang=js"
import style0 from "./UserEditDetails.vue?vue&type=style&index=0&id=795c905e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c905e",
  null
  
)

export default component.exports